import { memo } from 'react';

import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import * as S from './style';

interface IProps {
  imgSrc?: string;
  cardName?: string;
  desc?: string;
  amount?: string;
  bgColor?: string;
  textColor?: string;
  colorType?: 'black';
  onClick?: () => void;
}

const PaymentBenefitItem = ({
  imgSrc,
  cardName,
  desc,
  amount,
  bgColor,
  textColor,
  colorType,
  onClick,
}: IProps) => (
  <S.PaymentBenefitItem
    className="payment-benefit-item item"
    $bgColor={bgColor}
    $textColor={textColor}
    $colorType={colorType}
  >
    <Button onClick={onClick}>
      <Img src={imgSrc} alt={cardName} className="card-img" />
      <Text
        className="card-name"
        weight={500}
        size={14}
        lineHeight={16}
        ellipsis={2}
        block
      >
        {cardName}
      </Text>
      <Text className="desc" size={11} lineHeight={14} ellipsis={1} block>
        {desc}
      </Text>
      <Text
        className="amount"
        weight={600}
        size={16}
        lineHeight={20}
        ellipsis={1}
        block
      >
        {amount}
      </Text>
    </Button>
  </S.PaymentBenefitItem>
);

export default memo(PaymentBenefitItem);
